import { createContext, FC, PropsWithChildren, useContext } from 'react'
import { FederationRoot } from '@constructor/federation/base'
import { FederationContextProvider } from '@constructor/federation/react'

export const FederationContext = createContext<{
  root: FederationRoot | null
  isLoaded: boolean
  failedFragments: string[]
}>({
  root: null,
  isLoaded: false,
  failedFragments: [],
})

export const useFederation = () => {
  return useContext(FederationContext)
}

export const CustomFederationContextProvider: FC<
  PropsWithChildren<{ root: FederationRoot; isLoaded: boolean; failedFragments: string[] }>
> = ({ children, root, isLoaded, failedFragments }) => {
  return (
    <FederationContextProvider root={root}>
      <FederationContext.Provider value={{ root, isLoaded, failedFragments }}>{children}</FederationContext.Provider>
    </FederationContextProvider>
  )
}
